import { ErrorMessage, Rule } from '~domain/model/core/validation/rule';
import { BaseValidator } from '~domain/validators/core/base-validator';

export class RegexValidator extends BaseValidator<string> {
  protected rules: Rule<string>[] = [this.validateContent];

  // Error message to return
  private errorMessage: ErrorMessage;
  // Regex to test the value against
  private regex: RegExp;

  constructor(regex: RegExp, errorMessage?: ErrorMessage) {
    super();
    this.regex = regex;
    this.errorMessage = errorMessage || 'validation.error.invalidString';
  }

  private validateContent(value: string): ErrorMessage {
    if (!this.regex?.test(value)) {
      return this.errorMessage;
    }
  }
}
